export type HubPresencePublishedSnapshot = {
  routeKey: string;
  isVisible: boolean;
  presenceState: "active" | "idle";
};

/**
 * HTTP presence/update is for first paint, real navigation, visibility, idle/active
 * transitions, and periodic heartbeats. There is no per-tab EventSource.
 */
export function hubPresenceHttpUpdateIsNeeded(input: {
  lastPublished: HubPresencePublishedSnapshot | null;
  next: HubPresencePublishedSnapshot;
  force?: boolean;
}): boolean {
  if (input.force === true) {
    return true;
  }
  if (input.lastPublished == null) {
    return true;
  }
  return (
    input.lastPublished.routeKey !== input.next.routeKey ||
    input.lastPublished.isVisible !== input.next.isVisible ||
    input.lastPublished.presenceState !== input.next.presenceState
  );
}
